<template>
    <component :is="tag">
        <slot
            :proposalStep="step"
            :campaign="campaign"
            :proposal="proposal"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :isLoading="isLoading"
            :is-completing-proposal="isCompletingProposal"
        />
    </component>
</template>
<script>
    import BaseProposalStepMixin from "../mixins/BaseProposalStepMixin";
    import {NAME_CAMPAIGN_ASSETS} from '../../../constants/proposal-steps';

    export default {
        name: 'CompensationProvider',
        mixins: [
            BaseProposalStepMixin,
        ],
        computed: {
            step(){
                return this.proposalSteps[NAME_CAMPAIGN_ASSETS];
            },
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadCampaign(),
                        this.loadProposal(),
                    ]);
                })
                .then(() => {
                    this.initProposalStep(this.step);
                })
                .catch(error => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        }
    }
</script>
